document.addEventListener('DOMContentLoaded', function () {

  // ===== SCROLL: sticky header shadow =====
  var header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // ===== HERO SLIDESHOW =====
  var slides = document.querySelectorAll('.slide');
  var dots = document.querySelectorAll('.dot');
  var current = 0;
  var timer;

  function goTo(n) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
  }

  function autoPlay() { timer = setInterval(function () { goTo(current + 1); }, 5000); }

  if (slides.length) {
    autoPlay();
    document.querySelectorAll('.dot').forEach(function (dot) {
      dot.addEventListener('click', function () {
        clearInterval(timer);
        goTo(parseInt(dot.getAttribute('data-slide')));
        autoPlay();
      });
    });
    var prev = document.getElementById('slidePrev');
    var next = document.getElementById('slideNext');
    if (prev) prev.addEventListener('click', function () { clearInterval(timer); goTo(current - 1); autoPlay(); });
    if (next) next.addEventListener('click', function () { clearInterval(timer); goTo(current + 1); autoPlay(); });
  }

  // ===== MOBILE NAV =====
  var hamburger = document.getElementById('hamburgerBtn');
  var mobileNav = document.getElementById('mobileNav');
  var navOverlay = document.getElementById('navOverlay');
  var navClose = document.getElementById('navClose');

  function openNav() { mobileNav && mobileNav.classList.add('open'); navOverlay && navOverlay.classList.add('active'); document.body.style.overflow = 'hidden'; }
  function closeNav() { mobileNav && mobileNav.classList.remove('open'); navOverlay && navOverlay.classList.remove('active'); document.body.style.overflow = ''; }

  if (hamburger) hamburger.addEventListener('click', openNav);
  if (navClose) navClose.addEventListener('click', closeNav);
  if (navOverlay) navOverlay.addEventListener('click', closeNav);
  document.querySelectorAll('.mobile-nav a').forEach(function (l) { l.addEventListener('click', closeNav); });

  // ===== CUSTOMIZER TABS =====
  document.querySelectorAll('.panel-tab').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.panel-tab').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.panel-section').forEach(function (s) { s.classList.remove('active'); });
      btn.classList.add('active');
      var t = document.getElementById('tab-' + btn.getAttribute('data-tab'));
      if (t) { t.classList.add('active'); if (btn.getAttribute('data-tab') === 'preview') updatePreview(); }
    });
  });

  // ===== CUSTOMIZER STATE =====
  var state = { size: '3x8', basePrice: 189, metalCups: false, cupCount: 2, holeConfig: 'standard', design: 'classic', color: 'green' };

  function updatePrice() {
    var total = state.basePrice + (state.metalCups ? (state.cupCount === 4 ? 49 : 29) : 0);
    var fmt = '$' + total;
    var pp = document.getElementById('panelPrice');
    var sp = document.getElementById('summaryPrice');
    if (pp) pp.innerHTML = fmt + '<small> + free ship $150+</small>';
    if (sp) sp.textContent = fmt;
  }

  document.querySelectorAll('.size-btn[data-size]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.size-btn[data-size]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      state.size = btn.getAttribute('data-size');
      state.basePrice = parseInt(btn.getAttribute('data-price'), 10);
      updatePrice(); updatePreview();
    });
  });

  document.querySelectorAll('.hole-config-btn[data-config]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.hole-config-btn[data-config]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      state.holeConfig = btn.getAttribute('data-config');
      updatePreview();
    });
  });

  document.querySelectorAll('.size-btn[data-cup]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.size-btn[data-cup]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      state.metalCups = btn.getAttribute('data-cup') === 'metal';
      state.cupCount = (state.holeConfig === 'corners' || state.holeConfig === 'beerpong') ? 4 : 2;
      updatePrice();
    });
  });

  document.querySelectorAll('.hole-config-btn[data-design]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.hole-config-btn[data-design]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      state.design = btn.getAttribute('data-design');
      var us = document.getElementById('uploadSection');
      var sd = document.getElementById('standardDesignInfo');
      if (state.design === 'custom') {
        if (us) us.style.display = 'block';
        if (sd) sd.style.display = 'none';
      } else {
        if (us) us.style.display = 'none';
        if (sd) sd.style.display = 'block';
      }
    });
  });

  document.querySelectorAll('.size-btn[data-color]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.size-btn[data-color]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      state.color = btn.getAttribute('data-color');
      updatePreview();
    });
  });

  document.querySelectorAll('.size-btn[data-surface]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.size-btn[data-surface]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  function updatePreview() {
    var surface = document.getElementById('rugSurface');
    var label = document.getElementById('previewLabel');
    if (!surface) return;
    var colors = { green: '#2a5c3d', midnight: '#001F38', charcoal: '#2d2d2d' };
    surface.style.background = colors[state.color] || colors.green;
    surface.querySelectorAll('.preview-hole').forEach(function (h) { h.remove(); });
    var configs = {
      standard: [{ left:'12%',top:'50%',transform:'translateY(-50%)' },{ right:'12%',top:'50%',transform:'translateY(-50%)' }],
      beerpong: [{ left:'8%',top:'50%',transform:'translateY(-50%)' },{ left:'16%',top:'25%' },{ left:'16%',top:'75%',transform:'translateY(-100%)' },{ right:'8%',top:'50%',transform:'translateY(-50%)' },{ right:'16%',top:'25%' },{ right:'16%',top:'75%',transform:'translateY(-100%)' }],
      corners: [{ left:'10%',top:'18%' },{ right:'10%',top:'18%' },{ left:'10%',bottom:'18%' },{ right:'10%',bottom:'18%' }]
    };
    (configs[state.holeConfig] || configs.standard).forEach(function (pos) {
      var h = document.createElement('div');
      h.className = 'preview-hole';
      Object.keys(pos).forEach(function (k) { h.style[k] = pos[k]; });
      surface.appendChild(h);
    });
    if (label) label.textContent = state.size.replace('x', ' × ');
  }

  updatePreview(); updatePrice();

  // ===== FILE UPLOAD =====
  var fileInput = document.getElementById('fileInput');
  var uploadArea = document.getElementById('uploadArea');
  if (fileInput && uploadArea) {
    fileInput.addEventListener('change', function () {
      if (fileInput.files && fileInput.files[0]) {
        var p = uploadArea.querySelector('p');
        if (p) p.innerHTML = '<strong style="color:var(--midnight);">✓ ' + fileInput.files[0].name + '</strong><br><span style="font-size:0.75rem;color:var(--text-light);">Proof sent before production</span>';
        uploadArea.style.borderColor = 'var(--midnight)';
      }
    });
  }

  // ===== SMOOTH SCROLL =====
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(this.getAttribute('href'));
      if (t) { e.preventDefault(); window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' }); }
    });
  });

});
